import { DateTime } from 'luxon'
import { formatPhoneNumber } from 'react-phone-number-input'

import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { Card, CardColors, Heading, HeadingVariants, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

interface OptedInProps {
  createdAt: string
  mobilePhoneNumber?: string | null
}

export const OptedIn = ({ createdAt, mobilePhoneNumber }: OptedInProps) => {
  const getOptInDate = () => {
    if (!createdAt) return 'Update your SMS consent status'

    const optInDate = DateTime.fromISO(createdAt || '').toFormat(
      DATE_FORMATS_LUXON.DISPLAY_LONG
    )

    return `You opted into receiving notifications on ${optInDate}.`
  }

  return (
    <Card color={CardColors.LEVEL_1}>
      <Heading variant={HeadingVariants.H3}>Permissions</Heading>

      <div className="flex items-center justify-between gap-2">
        <Text>{getOptInDate()}</Text>
      </div>

      <Heading variant={HeadingVariants.H3}>Your Mobile Number</Heading>

      {mobilePhoneNumber && (
        <Text variant={TypographyStyles.H3}>
          {formatPhoneNumber(mobilePhoneNumber)}
        </Text>
      )}
    </Card>
  )
}
